import script from "./PublicUploadHandler.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicUploadHandler.vue?vue&type=script&setup=true&lang=ts"

import "./PublicUploadHandler.vue?vue&type=style&index=0&id=053e9ae1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-053e9ae1"]])

export default __exports__